import React from 'react';
import { APP_BRAND } from '../config/appConfig';

const BrandLogo = ({ className = 'app-brand-icon' }) => (
  <span className={className}>
    <img src={APP_BRAND.logoSrc} alt={APP_BRAND.logoAlt} />
  </span>
);

export default BrandLogo;
